import { CoreSetupAuditTrailViewsName } from './name';
import { deleteSetupAuditTrailViews } from '@api';
import { removeCoreSetupAuditTrailViewsSyncSlice } from './remove';

import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const deleteCoreSetupAuditTrailViewsSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [ removeCoreSetupAuditTrailViewsSyncSlice.syncActionCreator ]
	},
	name: CoreSetupAuditTrailViewsName,
	receive: false,
	request: true,
	requestHandler: deleteSetupAuditTrailViews,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Latest
});
